import css from 'styled-jsx/css'
import PageTitle from '../../components/page-title'
import Hero from '../../components/hero'

// ----------------------------------------------------------------------

const styles = css`
  .heroContainer {
    :global(.hero) {
      min-height: 26.2rem;
      height: 26.2rem;
      padding-top: 0;
    }

    .titleContainer {
      margin: 0 auto;
      padding: 0 1.2rem;

      :global(.pageTitle) {
        text-align: center;
        line-height: 26.2rem;
        color: var(--primary-bg-color);
      }
    }
  }

  @media (max-width: 1024px) {
    .heroContainer {
      :global(.hero) {
        min-height: 12rem;
        height: unset;
      }

      .titleContainer {
        margin: 0 auto;
        padding: 0 1.2rem;

        :global(.pageTitle) {
          text-align: center;
          line-height: 12rem;
          color: var(--primary-bg-color);
        }
      }
    }
  }
`

// ----------------------------------------------------------------------

export default function HeroSection() {
  return (
    <div className='heroContainer'>
      <Hero desktopImageSrc='/images/heroes/help.jpg' opacity={1}>
        <div className='titleContainer'>
          <PageTitle>Dealer Sign Up</PageTitle>
        </div>
      </Hero>

      <style jsx>{styles}</style>
    </div>
  )
}
